/**
 * Using .toLocaleString() does not consistently return a number with two decimal values.
 * This function checks if the string has the correct amount of decimal values and makes corrections incase there's an incorrect amount.
 * 
 * @param {String} value A string that comes from a .toLocaleString() {ex: (1123.4).toLocaleString()}
 * @returns A modified .toLocaleString which always has two decimal values
 */
export function checkIfTwoDecimalPlaces(value) {
    if (value == 0) {
        return "0.00"
    } else {
        const split = value.split(".")
        if (split.length > 1) {
            // If number has decimal values
            const decimalVal = split[1]
            if (decimalVal.length < 2) return `${value}0`
            else return value
        } else {
            return `${value}.00`
        }
    }
}
